import { render, staticRenderFns } from "./SplitSection.vue?vue&type=template&id=c5cb2234"
import script from "./SplitSection.vue?vue&type=script&lang=js"
export * from "./SplitSection.vue?vue&type=script&lang=js"
import style0 from "./SplitSection.vue?vue&type=style&index=0&id=c5cb2234&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports